import React from 'react'
import { Link } from 'react-router-dom'
import Typography from 'material-ui/Typography'
import Icon from 'material-ui/Icon'

const Breadcrumbs = ({ items }) => {
  const rootStyle = {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
  }

  const breadcrumbStyle = {
    display: 'flex',
    alignItems: 'center'
  }

  const linkStyle = {
    color: 'inherit',
    textDecoration: 'none',
    cursor: 'pointer',
    fontSize: '0.875rem'
  }

  const currentStyle = {
    color: 'inherit',
    fontWeight: '600',
    fontSize: '0.875rem',
    opacity: 0.8
  }

  const separatorStyle = {
    color: 'inherit',
    fontSize: '18px',
    opacity: 0.6,
    marginRight: '8px'
  }

  return (
    <div style={rootStyle}>
      {items && items.map((item, index) => (
        <div key={index} style={breadcrumbStyle}>
          {item.link ? (
            <Typography
              component={Link}
              to={item.link}
              style={{ ...linkStyle, marginRight: '8px' }}
            >
              {item.label}
            </Typography>
          ) : (
            <Typography style={{ ...currentStyle, marginRight: '8px' }}>
              {item.label}
            </Typography>
          )}
          {index < items.length - 1 && (
            <Icon style={separatorStyle}>chevron_right</Icon>
          )}
        </div>
      ))}
    </div>
  )
}

export default Breadcrumbs
